import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface SecretHistoryEntry {
  id: string;
  secret_id: string;
  version: number;
  value: string;
  changed_by?: string;
  changed_at: string;
}

interface HistoryResponse {
  history: SecretHistoryEntry[];
}

export function useSecretHistory(
  projectId: string | null,
  environmentSlug: string | null,
  secretKey: string | null
) {
  const basePath =
    projectId && environmentSlug && secretKey
      ? `/api/v1/projects/${projectId}/environments/${environmentSlug}/secrets/${encodeURIComponent(secretKey)}/history`
      : null;

  const historyQuery = useQuery({
    queryKey: ['secretHistory', projectId, environmentSlug, secretKey],
    queryFn: async () => {
      if (!basePath) return [];
      const response = await apiClient.get<HistoryResponse>(basePath);
      return response.data.history;
    },
    enabled: !!basePath,
    staleTime: 1000 * 30, // 30 seconds
  });

  return {
    history: historyQuery.data ?? [],
    isLoading: historyQuery.isLoading,
    error: historyQuery.error,
    refetch: historyQuery.refetch,
  };
}
